import { createSlice } from "@reduxjs/toolkit";

export const refetchDataSlice = createSlice({
  name: "refetch",
  initialState: {
    value: true,
  },
  reducers: {
    setIsDataRefetch: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setIsDataRefetch } = refetchDataSlice.actions;
export default refetchDataSlice.reducer;
